import React, { useState } from "react";
import api from "@/lib/api";
import { Search, Filter } from "lucide-react";
import { toast } from "sonner";

export default function AdminLogs() {
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(false);
  const [filters, setFilters] = useState({
    email: "",
    phone: "",
    transaction_id: "",
    event_type: "",
  });

  const searchLogs = async () => {
    try {
      setLoading(true);
      const res = await api.get("/admin/logs", { params: filters });
      setLogs(res.data.logs);
    } catch (error) {
      toast.error("Erro ao buscar logs");
    } finally {
      setLoading(false);
    }
  };

  const getStatusColor = (status) => {
    const colors = {
      success: "text-emerald-500",
      error: "text-red-500",
      warning: "text-yellow-500",
    };
    return colors[status] || "text-zinc-400";
  };

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold text-white">Logs / Dev Center</h1>
        <p className="text-zinc-400 mt-1">Busca avançada de logs do sistema</p>
      </div>

      {/* Search Filters */}
      <div className="bg-zinc-900 border border-zinc-800 rounded-xl p-6 space-y-4">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
          <input
            type="text"
            placeholder="Email do cliente"
            value={filters.email}
            onChange={(e) => setFilters({ ...filters, email: e.target.value })}
            className="px-4 py-2 bg-zinc-800 border border-zinc-700 rounded-lg text-white placeholder-zinc-500 focus:outline-none focus:ring-2 focus:ring-emerald-500"
          />
          <input
            type="text"
            placeholder="Telefone"
            value={filters.phone}
            onChange={(e) => setFilters({ ...filters, phone: e.target.value })}
            className="px-4 py-2 bg-zinc-800 border border-zinc-700 rounded-lg text-white placeholder-zinc-500 focus:outline-none focus:ring-2 focus:ring-emerald-500"
          />
          <input
            type="text"
            placeholder="Transaction ID"
            value={filters.transaction_id}
            onChange={(e) => setFilters({ ...filters, transaction_id: e.target.value })}
            className="px-4 py-2 bg-zinc-800 border border-zinc-700 rounded-lg text-white placeholder-zinc-500 focus:outline-none focus:ring-2 focus:ring-emerald-500"
          />
          <select
            value={filters.event_type}
            onChange={(e) => setFilters({ ...filters, event_type: e.target.value })}
            className="px-4 py-2 bg-zinc-800 border border-zinc-700 rounded-lg text-white focus:outline-none focus:ring-2 focus:ring-emerald-500"
          >
            <option value="">Todos os eventos</option>
            <option value="webhook_received">Webhook recebido</option>
            <option value="api_query_success">API sucesso</option>
            <option value="api_query_failed">API falhou</option>
            <option value="recovery_started">Recuperação iniciada</option>
            <option value="message_sent">Mensagem enviada</option>
          </select>
        </div>
        <button
          onClick={searchLogs}
          disabled={loading}
          className="w-full md:w-auto px-6 py-2 bg-emerald-500 hover:bg-emerald-600 disabled:bg-emerald-500/50 text-white rounded-lg flex items-center justify-center gap-2"
        >
          <Search size={18} />
          {loading ? "Buscando..." : "Buscar Logs"}
        </button>
      </div>

      {/* Logs Table */}
      {logs.length > 0 && (
        <div className="bg-zinc-900 border border-zinc-800 rounded-xl overflow-hidden">
          <div className="overflow-x-auto">
            <table className="w-full">
              <thead className="bg-zinc-800/50">
                <tr>
                  <th className="px-6 py-3 text-left text-xs font-medium text-zinc-400 uppercase">
                    Data/Hora
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-zinc-400 uppercase">
                    Cliente
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-zinc-400 uppercase">
                    Evento
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-zinc-400 uppercase">
                    Status
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-zinc-400 uppercase">
                    Mensagem
                  </th>
                </tr>
              </thead>
              <tbody className="divide-y divide-zinc-800">
                {logs.map((log, idx) => (
                  <tr key={idx} className="hover:bg-zinc-800/30">
                    <td className="px-6 py-4 text-sm text-zinc-400">
                      {new Date(log.created_at).toLocaleString("pt-BR")}
                    </td>
                    <td className="px-6 py-4">
                      <div>
                        <div className="text-sm text-white">{log.user?.name || "-"}</div>
                        <div className="text-xs text-zinc-400">{log.user?.email || "-"}</div>
                      </div>
                    </td>
                    <td className="px-6 py-4 text-sm text-zinc-400">
                      {log.event_type || "-"}
                    </td>
                    <td className="px-6 py-4">
                      <span className={`text-sm font-medium ${getStatusColor(log.status)}`}>
                        {log.status || "unknown"}
                      </span>
                    </td>
                    <td className="px-6 py-4 text-sm text-zinc-400 max-w-md truncate">
                      {log.message || log.error || "-"}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}

      {!loading && logs.length === 0 && (
        <div className="bg-zinc-900 border border-zinc-800 rounded-xl p-12 text-center text-zinc-400">
          Use os filtros acima para buscar logs
        </div>
      )}
    </div>
  );
}
